function favoriteTrips(state=[], action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
    case 'USER_SUCCESS':
      return [
        // ...state,
        ...action.user.favorite_trips
      ]
    // case 'RECEIVE_FAVE_TRIPS':
    //   return [
    //     // ...state,
    //     ...action.trips
    //   ]
      // TODO map through and assign from / to fave places here instead(?)
      // from: action.favoritePlaces.find(place=>place.token_id==trip.start_place_token).street,
      // from: action.favoritePlaces.byId[trip.start_place_token],

    case 'ADD_FAVE_TRIP':
      return [
        ...state,
        {
          // id: state.length+1,
          ...action.trip,
        }
      ]
    case 'UPDATE_FAVE_TRIP':
      return state.map((trip, index)=>{
        if (trip.token_id === action.trip.token_id) {
          return {
            ...trip,
            ...action.trip,
          }
        }
        return trip
      })

    case 'LOGOUT_SUCCESS':
      return []

    default:
      return state
  }
}

export default favoriteTrips



// WEBPACK FOOTER //
// ./src/models/favoriteTrips.js